import { Button } from '@leroy-merlin-br/backyard-react-ui'

import { Field } from 'lmcv/components/Field'

import WizardStep from '../components/WizardStep'
import isValid from '../utils/isValid'
import * as Ilustrations from '../components/Ilustrations'
import * as S from '../styled'

const ProjectName = ({
  step,
  errors,
  register,
  nextStep,
  customerData
}) => {
  const { name, projectName } = customerData

  const isDisabled = (!isValid(name) || !isValid(projectName))

  return (
    <WizardStep step={1} currentStep={step}>
      <Ilustrations.People />
      <Field
        type="text"
        name="name"
        title="Nome do Cliente"
        reference={register({ required: true, maxLength: 40 })}
        errors={errors?.name}
      />
      <Field
        type="text"
        name="projectName"
        title="Nome do Projeto"
        placeholder="Ex: Cozinha integrada"
        reference={register({ required: true, maxLength: 40 })}
        errors={errors?.projectName}
      />
      <S.ButtonWrapper>
        <Button
          type="submit"
          size="kilo"
          onClick={nextStep}
          isDisabled={isDisabled}
          isStretch
        >
          Próxima etapa
        </Button>
      </S.ButtonWrapper>
    </WizardStep>
  )
}

export default ProjectName
